import { useQuery } from '@tanstack/react-query';
import { getContentFilterOptionsOptions } from '@/utils/queryOptions';
import { TContentFilterOption } from '@/types/Content.types';

// Personalized filter options for the modal.
//
// `includeAllTopics` pulls the full topic catalog (grouped by domain) for the "All
// Topics" view; without it the response carries only the personalized short-list — the
// viewer's lowest-scoring subdomains — shown as the main "Filter per Topic" chips.
const useContentFilterOptions = (includeAllTopics = false) => {
  const { data, isLoading, isError } = useQuery(getContentFilterOptionsOptions(includeAllTopics));

  return {
    // The personalized short-list of topics (main sheet).
    topics: (data?.topic ?? []) as TContentFilterOption[],
    // Full catalog grouped by domain (All Topics view). Empty unless includeAllTopics.
    allTopicGroups: data?.allTopics ?? [],
    isLoading,
    isError,
  };
};

export default useContentFilterOptions;
